var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "title", class: "title--" + _vm.size }, [
    _vm.h1
      ? _c("h1", {
          staticClass: "title__text",
          domProps: { innerHTML: _vm._s(_vm.text) },
        })
      : _c("div", {
          staticClass: "title__text",
          domProps: { innerHTML: _vm._s(_vm.text) },
        }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }